var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4578_253972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5196 12.7648L19.6446 8.63978C19.8382 8.44632 19.9917 8.21663 20.0964 7.96383C20.2011 7.71103 20.255 7.44008 20.255 7.16645C20.255 6.89281 20.2011 6.62186 20.0964 6.36906C19.9917 6.11627 19.8382 5.88658 19.6446 5.69311L15.5196 1.56812L14.338 2.74978L17.9213 6.33312H2.83797C2.16972 6.31766 1.52259 6.56773 1.03837 7.02852C0.55415 7.48931 0.272323 8.12325 0.254639 8.79145L0.254639 18.0414C0.272323 18.7096 0.55415 19.3436 1.03837 19.8044C1.52259 20.2652 2.16972 20.5152 2.83797 20.4998H18.588V18.8331H2.83797C2.61175 18.8483 2.38867 18.7737 2.21708 18.6255C2.04548 18.4773 1.93922 18.2675 1.92131 18.0414V8.79145C1.93922 8.56543 2.04548 8.35558 2.21708 8.20739C2.38867 8.05919 2.61175 7.9846 2.83797 7.99978H17.9271L14.3438 11.5831L15.5196 12.7648Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4578_253972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.254639 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.df8f0ec2bd238331bc4b8ff844092202.svg";
export { ForwardRef as ReactComponent };